export default __webpack_public_path__ + "static/media/Uno.835f69b5.svg";